import { LoaderCircle } from "lucide-react";

const Loading = () => {
  return (
    <div className="bg-muted flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <LoaderCircle className="size-6 animate-spin" />
    </div>
  );
};

export default Loading;
